import { render, staticRenderFns } from "./DegreeMapSemesterInfo.vue?vue&type=template&id=4b198290"
import script from "./DegreeMapSemesterInfo.vue?vue&type=script&lang=js"
export * from "./DegreeMapSemesterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports